export const jnsWorks = {
  movie: [
    {
      id: 1,
      title: '행복의나라',
      year: '2023',
      image: require('./movie/1. 행복의나라.jpeg')
    },
    {
      id: 2,
      title: '야당',
      year: '2022',
      image: require('./movie/2. 야당.jpeg')
    },
    {
      id: 3,
      title: '서울의 봄',
      year: '2021',
      image: require('./movie/3. 서울의 봄.jpeg')
    },
    {
      id: 4,
      title: '마녀2',
      year: '2021',
      image: require('./movie/4. 마녀2.jpeg')
    },
    {
      id: 5,
      title: '해적2',
      year: '2020',
      image: require('./movie/5. 해적2.jpeg')
    },
    {
      id: 6,
      title: '아내를 죽였다',
      year: '2019',
      image: require('./movie/6. 아내를 죽였다.jpeg')
    },
  ],
  drama: [
    {
      id: 1,
      title: '위기의X',
      year: '2022',
      image: require('./drama/1. 위기의X (드라마).webp')
    },
    {
      id: 2,
      title: '이태원 클라쓰',
      year: '2019',
      image: require('./drama/2. 이태원 클라쓰(드라마).jpg')
    },
  ],
}
